module.exports = "build/assets/grandpa.14bc3f55.png";